import React from 'react'
import { LoginPanelStyle as Wrapper } from '../style'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Button } from 'antd'

import { actions as authAction } from '../store'

class LoginPanel extends React.Component {
  state = {
    isLoading: false,
    ssoToken: null
  }

  componentDidMount() {
    const ssoToken = localStorage.getItem('sso_access_token')
    localStorage.removeItem('sso_access_token')

    if(ssoToken) {
      const { loginWithToken } = this.props
      loginWithToken(ssoToken)
      this.setState({ ssoToken: ssoToken })
    }
  }

  processSSOLogin = () => {
    const redirectUrl = `${window.location.href}callback`
    const endpoint = process.env.REACT_APP_SSO_URL
    const bundle = process.env.REACT_APP_SSO_APP
    const url = `${endpoint}?identifier=${bundle}&redirect_url=${redirectUrl}`

    window.location.href = url
  }

  loginSuccess = token => {
    const { loginWithToken } = this.props
    loginWithToken(token)
  }

  chooseAccount = account => {
    const { selectAccount } = this.props
    selectAccount(account, this.state.ssoToken)
  }

  showAvailableAccount = () => {
    const { availableList, isFailLogin, loadProfileError } = this.props
    if (availableList.length > 0) {
      return (
        <div>
          <div className="chooseMsg">กรุณาเลือกบัญชีที่ต้องการใช้งาน</div>
            { loadProfileError && (
              <div className="forbidden">ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง</div>
            )}
            <ul className="list">
            { availableList.map((value, i) => {
              return (
                <li key={i}>
                  <Link to={'#'} onClick={() => this.chooseAccount(value)}>
                    <div className="title">{ value.name }</div>
                    <div className="detail">{ value.roles != null ? value.roles.toUpperCase() : 'ไม่ระบุ' }</div>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      )
    }
    else if(isFailLogin) {
      return (
        <div className="forbidden">ไม่สามารถ<br/>กรุณาติดต่อผู้ดูแลระบบของคุณ</div>
      )
    }
    else {
      return (
        <div className="forbidden">คุณไม่มีสิทธิ์ในการเข้าใช้งานระบบ<br/>กรุณาติดต่อผู้ดูแลระบบของคุณ</div>
      )
    }
  }

  render() {
    const { isLoading, listLoaded, isLogin } = this.props

    if (isLogin) {
      return <Redirect to={'/search'} />
    }

    return (
      <Wrapper>
        <div className="container">
          <div className="logo">
            <div className="image">
              <img src={'/images/logo256x256.png'} alt="logo"/>
            </div>
            <div className="title">Privage Web Partner</div>
            <div className="detail">ระบบจัดการแอปพลิเคชั่นพริเวจ</div>
          </div>

          { !listLoaded ? (
            <div className="action">
              <Button type="primary" loading={isLoading} icon={'lock'} size="large" onClick={this.processSSOLogin}>
                เข้าสู่ระบบด้วยบัญชี Privage
              </Button>
            </div>
          ) : (
            <div className="action">
              { this.showAvailableAccount() }
              <Button type="primary" loading={isLoading} icon={'lock'} size="large" onClick={this.processSSOLogin}>
                เข้าสู่ระบบด้วยบัญชีอื่น
              </Button>
          </div>
          )}

          <div className="footer">
            <div className="link">
              <a href="https://www.privageapp.com/terms" rel="noopener noreferrer" target="_blank">เงื่อนไขการใช้งาน</a> &nbsp;|&nbsp;  
              <a href="https://www.privageapp.com/privacy" rel="noopener noreferrer" target="_blank">นโยบายความเป็นส่วนตัว</a>
            </div>
            <div className="licence">&copy; 2018 Privage App Co.,Ltd.</div>
          </div>
        </div>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  ...state.auth
})

const mapDispatchToProps = {
  loginWithToken: authAction.loginWithToken,
  selectAccount: authAction.selectAccount
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPanel)


// WEBPACK FOOTER //
// ./src/containers/Auth/components/LoginPanel.js